import cn from 'classnames';
import { ComponentType, ReactNode, useCallback } from 'react';

import styles from './TabTitle.module.scss';
import { TabItemProps } from './TabItem';

export interface TabTitleProps<T> extends TabItemProps<T> {
  title: ReactNode;
  onClick(key: T): void;
  tabName: T;
  isActive?: boolean;
  disabled?: boolean;
  icon?: ComponentType;
}

export function TabTitle<T>({
  isActive,
  title,
  onClick,
  tabName,
  disabled,
  icon: Icon,
  count,
}: TabTitleProps<T>) {
  const handleClick = useCallback(() => {
    if (disabled) return;
    onClick(tabName);
  }, [disabled, onClick, tabName]);

  return (
    <li
      className={cn(styles.tabTitle, {
        [styles.active]: isActive,
        [styles.disabled]: disabled,
      })}
      role="none"
      onClick={handleClick}
    >
      <span className={styles.pre} />
      <span className={styles.container}>
        {title}
        {Icon && <Icon />}
        {Boolean(count) && <span className={styles.count}>{count}</span>}
      </span>
      <span className={styles.post} />
    </li>
  );
}
